// extracted by mini-css-extract-plugin
export default {"screensTableOuter":"screeeningdetails_screensTableOuter__5JO1D"};